export default __webpack_public_path__ + "static/source-top-72aabb1ac2a42cce4b68d86ba30026dd.png";